import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
  import useIcons from '@/composables/useIcons'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import type { PropType } from 'vue'
  import type { LeuckentextChoice } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LeuckentextAnswersPane',
  props: {
    choices: {
      type: Array as PropType<LeuckentextChoice[]>,
      required: true,
    },
    inResultsMode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['dragged-answer', 'drag-end', 'reset-all-answers'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const { menuIcon } = useIcons()
  const draggedChoice = ref('')

  const showResetCTA = computed(() => {
    return props.inResultsMode ? false : props.choices.some((choice) => !choice.selectable)
  })

  const onDragStart = (choiceId: string) => {
    draggedChoice.value = choiceId
    emit('dragged-answer', choiceId)
  }

  const onDragEnd = () => {
    draggedChoice.value = ''
    emit('drag-end')
  }

return { __sfc: true,props, emit, menuIcon, draggedChoice, showResetCTA, onDragStart, onDragEnd, computed, ref, useIcons, SVGRenderer }
}

})